import React, { useEffect, useState } from "react";
import classes from "./MeterSubscription.module.css";
import { useDispatch, useSelector } from "react-redux";
import { handleloading } from "../../Store/Redux/Reducers/Dashboardreducers";
import { GetSubscription, SendSubscription } from "../../Services/ApiServices";
import {
  CatchMessage,
  JSONtoformdata,
  tokenisValid,
} from "../../Shared/Methods";
import { toast } from "react-toastify";
import { HandleSessionModal } from "../../Store/Redux/Reducers/Authreducers";
import { MdKeyboardArrowLeft, MdKeyboardArrowRight } from "react-icons/md";
import CommonButton from "../Buttons/CommonButton";
import CommonNodataFound from "../CommonNodataFound";

function MeterSubscription({ item }: { item: any }) {
  const { LoginData } = useSelector((state: any) => state.Auth);
  const dispatch = useDispatch();
  const [subscriptionList, setSubscriptionList] = useState<any>([]);

  const [activeSlide, setactiveSlide] = useState(0);
  const next = () =>
    activeSlide < subscriptionList?.length - 1 &&
    setactiveSlide(activeSlide + 1);
  const prev = () => activeSlide > 0 && setactiveSlide(activeSlide - 1);
  const [showText, setShowText] = useState<any>({ isView: false, index: "" });

  useEffect(() => {
    if (LoginData !== null) {
      handleGetDeviceList();
    }
  }, [LoginData]);

  const handleGetDeviceList = () => {
    dispatch(handleloading(true));

    let finalObj = {
      token: LoginData?.token,
    };

    GetSubscription(JSONtoformdata(finalObj))
      .then(async (res) => {
        if (res.data.status === 1) {
          setSubscriptionList(
            res.data.data.map((ele: any) => {
              return { ...ele, bgColor: "#20a2a0" };
            })
          );
        } else if (res.data.status === -1) {
          const istokenValid = await tokenisValid(LoginData?.token);
          if (istokenValid) {
            toast.error(res.data.msg);
          } else {
            dispatch(HandleSessionModal(true));
          }
        } else {
          toast.error(res.data.msg);
        }
      })
      .catch((err) => CatchMessage(err))
      .finally(() => {
        dispatch(handleloading(false));
      });
  };

  const getStyles = (index: number) => {
    if (activeSlide === index)
      return {
        opacity: 1,
        transform: "translateX(0px) translateZ(0px) rotateY(0deg)",
        zIndex: 10,
      };
    else if (activeSlide - 1 === index)
      return {
        opacity: 1,
        transform: "translateX(-240px) translateZ(-400px) rotateY(35deg)",
        zIndex: 9,
      };
    else if (activeSlide + 1 === index)
      return {
        opacity: 1,
        transform: "translateX(240px) translateZ(-400px) rotateY(-35deg)",
        zIndex: 9,
      };
    else if (activeSlide - 2 === index)
      return {
        opacity: 1,
        transform: "translateX(-480px) translateZ(-500px) rotateY(35deg)",
        zIndex: 8,
      };
    else if (activeSlide + 2 === index)
      return {
        opacity: 1,
        transform: "translateX(480px) translateZ(-500px) rotateY(-35deg)",
        zIndex: 8,
      };
    else if (index < activeSlide - 2)
      return {
        opacity: 0,
        transform: "translateX(-480px) translateZ(-500px) rotateY(35deg)",
        zIndex: 7,
      };
    else if (index > activeSlide + 2)
      return {
        opacity: 0,
        transform: "translateX(480px) translateZ(-500px) rotateY(-35deg)",
        zIndex: 7,
      };
  };

  const handleSendSubscription = (data: any) => {
    dispatch(handleloading(true));

    let finalObj = {
      token: LoginData?.token,
      subscription_id: data?.subscription_id || "",
      subscription_name: data?.subscription_name || "",
      subscription_description: data?.subscription_description || "",
      validity: data?.validity || "",
      cost: data?.cost || "",
      meter_id: item?.meter_id,
    };

    SendSubscription(JSONtoformdata(finalObj))
      .then(async (res) => {
        if (res?.data?.status === 1) {
          toast.success(res?.data?.msg);
        } else if (res?.data?.status === 0) {
          const istokenValid = await tokenisValid(LoginData?.token);
          if (istokenValid) {
            toast.error(res?.data?.msg);
          } else {
            dispatch(HandleSessionModal(true));
          }
        } else {
          toast.error(res?.data?.msg);
        }
      })
      .catch((err) => CatchMessage(err))
      .finally(() => {
        dispatch(handleloading(false));
      });
  };

  return (
    <>
      {subscriptionList?.length > 0 ? (
        <>
          {" "}
          <div style={{ marginTop: "40px" }}>
            <div className={classes.slideC}>
              {subscriptionList?.map((ele: any, index: number) => {
                let Description = ele?.subscription_description.split("\n");

                return (
                  <>
                    <div
                      className={classes.slide}
                      style={{
                        background: "white",
                        boxShadow: `grey 0px 0px 12px 0px`,
                        borderRadius: "15px",
                        ...getStyles(index),
                      }}
                    >
                      <div className={classes.sub_container_bottom}>
                        <p className={`${classes.pro_text} m-0`}>
                          {ele?.subscription_name}
                        </p>
                      </div>
                      <div style={{ padding: "15px" }}>
                        <p className={classes.pro_count_center}>
                          <span className={classes.pro_count}>
                            {ele?.subscription_price}
                          </span>
                          /{ele?.subscription_month}
                        </p>
                        <div className={classes.description_parent_container}>
                          <p
                            className={`${classes.description_container} scroll_inner`}
                            style={
                              showText.isView && index === showText.index
                                ? { height: "auto" }
                                : {}
                            }
                          >
                            {Description?.map((ele: any, ind: number) => {
                              return <p>{ele}</p>;
                            })}
                          </p>
                        </div>

                        <div
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            marginTop: "15px",
                          }}
                        >
                          <CommonButton
                            name="Select"
                            type="button"
                            onClick={() => {
                              handleSendSubscription(ele);
                            }}
                            classname="submit_btn"
                          />
                        </div>
                      </div>
                    </div>
                  </>
                );
              })}
            </div>
          </div>
          <div className={classes.btns}>
            <MdKeyboardArrowLeft
              onClick={prev}
              color={activeSlide === 0 ? "#808080" : "#000000"}
              size={30}
            />
            <MdKeyboardArrowRight
              onClick={next}
              color={
                activeSlide === subscriptionList?.length - 1
                  ? "#808080"
                  : "#000000"
              }
              size={30}
            />
          </div>
        </>
      ) : (
        <CommonNodataFound />
      )}
    </>
  );
}

export default MeterSubscription;
